import { GracefulWorkerService } from "legacy/utils/WorkerUtil";

export const worker = new GracefulWorkerService({
  workerLoader: () =>
    import(
      /* webpackChunkName: "evaluation-worker" */
      "worker-loader?inline=no-fallback!../workers/evaluation.worker"
    ),
});
